import React from "react";
import { TransformedAddress } from "../../cart/types/cartApiTypes";

interface OrderAddressCardProps {
  title: string;
  address?: TransformedAddress;
  type: "billing" | "shipping";
}

const OrderAddressCard: React.FC<OrderAddressCardProps> = ({
  title,
  address,
  type,
}) => {
  if (!address) return null;

  // --- 1. Access Global Data directly ---
  // We need to look up states for ANY country, not just TR.
  const allCountryStates = window.checkoutFlowVariables?.countryStates || {};
  const allowedCountries = window.checkoutFlowVariables?.allowedCountries || {};

  // --- 2. Dynamic Lookup Logic ---

  // Resolve State Name
  const statesForCountry = allCountryStates[address.country] || {};
  const stateName = address.state
    ? statesForCountry[address.state] || address.state
    : "";

  // Resolve Country Name
  const countryName = allowedCountries[address.country] || address.country;

  return (
    <div className="order-page__details-card">
      <h3>{title}</h3>
      <address>
        <strong>
          {address.firstName} {address.lastName}
        </strong>
        <br />
        {type === "billing" && address.company && (
          <>
            {address.company}
            <br />
          </>
        )}
        {address.address1}
        <br />
        {address.address2 && (
          <>
            {address.address2}
            <br />
          </>
        )}
        {/* Render constructed location line */}
        {address.postcode} {address.city} {stateName ? `/ ${stateName}` : ""}
        <br />
        {countryName}
        <br />
        {address.phone && (
          <>
            {address.phone}
            <br />
          </>
        )}
        {type === "billing" && address.email && <>{address.email}</>}
      </address>
    </div>
  );
};

export default OrderAddressCard;
